import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { StoreButton } from '../Login.styles';
import { Text, Flex } from '@components';
import accessAppStoreQr from '@assets/images/swise_access_app_qr.png';
import DownloadAppStoreBlack from '@assets/svg/download_app_store_black.svg';
import DownloadGooglePlayStoreBlack from '@assets/svg/download_google_play_store_black.svg';
import { APPLE_STORE_APP_URL, GOOGLE_PLAY_STORE_APP_URL } from '../Login';
import { deviceUtils } from '@utils/device/deviceUtils';

export const DownloadApp = (): JSX.Element => {
  const theme = useTheme();
  const isUserUsingMobile = deviceUtils.isUserUsingMobile();

  return (
    <Flex alignItems='flex-start' flexDirection='column' pt={16} gap={17}>
      <Flex alignItems='center' flexDirection='column' gap={15}>
        <Text variant='h4' fontWeight='fontWeightBold'>
          <FormattedMessage id='login.downloadAccessAppTitle' />
        </Text>
        <Text
          variant='h5'
          textAlign='center'
          fontWeight='fontWeightRegular'
          style={{
            color: theme.palette.grey.A100,
            marginTop: theme.spacing(3),
          }}
        >
          <FormattedMessage id='login.downloadAccessAppDescriptionFirst' />
        </Text>
        <Text
          variant='h5'
          textAlign='center'
          fontWeight='fontWeightRegular'
          style={{
            color: theme.palette.grey.A100,
            marginTop: theme.spacing(3),
          }}
        >
          <FormattedMessage id='login.downloadAccessAppDescriptionSecond' />
        </Text>
      </Flex>

      <Flex width='100%' flexDirection='column' alignItems='center' gap={10}>
        <Text variant='h6' fontWeight='fontWeightMedium' textAlign='center'>
          <FormattedMessage
            id={
              isUserUsingMobile
                ? 'login.downloadAppMobile'
                : 'login.downloadApp'
            }
          />
        </Text>
        {isUserUsingMobile ? null : (
          <Flex justifyContent='center' alignSelf='center'>
            <img
              style={{ height: 150 }}
              src={accessAppStoreQr ?? ''}
              alt='QR code'
            />
          </Flex>
        )}
        <Flex gap={10}>
          <StoreButton
            alt='Download on the App Store button'
            src={DownloadAppStoreBlack}
            onClick={() => window.open(APPLE_STORE_APP_URL, '_blank')}
          />
          <StoreButton
            alt='Download on the Google Play Store button'
            src={DownloadGooglePlayStoreBlack}
            onClick={() => window.open(GOOGLE_PLAY_STORE_APP_URL, '_blank')}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
